import "./footer.scss"
import {SiBuymeacoffee, SiInstagram, SiFacebook, SiLinkedin, SiTwitter, SiGmail, SiTelegram, SiLeetcode, SiHackerrank, SiGithub, SiBlogger} from "react-icons/si"
import {RiCopyrightLine} from "react-icons/ri"

export default function footer() {
    return (
        <div className="footer" id="footer">
            <button onClick={() => window.open('https://www.buymeacoffee.com/Adheena')}>Buy me a coffee <SiBuymeacoffee/></button>
            <div className="socials">
                <a href="https://www.instagram.com/lavenderrayyy/"><span><SiInstagram/></span></a>
                <a href="https://github.com/AdheenaBabu"><span><SiGithub/></span></a>
                <a href="https://www.linkedin.com/in/adheena-babu-92a80a1bb/"><span><SiLinkedin/></span></a>
                <a href="mailto:babu.adheena.2001@gmail.com"><span><SiGmail/></span></a>
                <a href="https://leetcode.com/Adheena_B/"><span><SiLeetcode/></span></a>
                <a href="https://www.hackerrank.com/Adheena"><span><SiHackerrank/></span></a>
                <a href="https://adheenaadhi.blogspot.com/"><span><SiBlogger/></span></a>
                <a href="https://twitter.com/Adheena05855608"><span><SiTwitter/></span></a>
                <a href="https://t.me/AdheenaBabu"><span><SiTelegram/></span></a>
                <a href="https://www.facebook.com/profile.php?id=100070645232253"><span><SiFacebook/></span></a>
            </div>
            <div className="copyright">
                <h4>Copyrights <RiCopyrightLine/> 2021 All rights reserved</h4>
                <h4>Designed by Adheena</h4>
            </div>
        </div>
    )
}
